/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useRef, useState } from 'react';
import React from 'react';

import { useMantineTheme } from '@mantine/core';
import { Dropzone, IMAGE_MIME_TYPE } from '@mantine/dropzone';
import { useMutation } from 'react-query';
import { useDispatch } from 'react-redux';
import { useTypedSelector } from '../../../../hooks/useTypeSelector';
import { SetNotificationAction } from '../../../../redux/actions/notificationAction';
import { stateNotificationsEnum } from '../../../Utils/notification';
import { globalEnv } from '../../../../config/baseConfig';
import {
	dropzoneChildren,
	uploadFilesAndGetLocation,
	IFile,
	IUploadFile,
	readImages,
	uploadStateValues,
	readVideos
} from '../../../Utils/upload/uploadImagesUtils';
import SaveButton from '../../../Utils/saveButton';
import { MediaType } from '..';
import axiosInstance from '../../../../config/axiosInstance';

type TopicProps = {
	setModalOpen: (isOpen: boolean) => void;
	topicName: string;
	topicId: string;

	isChanged: boolean;
	mediaType: MediaType;
	setIsChanged: (isChanged: boolean) => void;
	setIsWarnModalOpen: (isOpen: boolean) => void;
	media: any[];
	setMedia: (media: any[]) => void;
	setMediaCount: (mediaCount: number) => void;
	mediaCount: number;
};

export function AddMediaModalContent(props: TopicProps) {
	const cancelButtonRef = useRef(null);

	const theme = useMantineTheme();
	const [uploadMedia, setUploadMedia] = useState<IFile[]>([]);
	const [uploadFiles, setUploadFiles] = useState<IUploadFile[]>([]);

	const dispatch = useDispatch();

	const { ACCESS_TOKEN } = useTypedSelector((state) => state.auth);

	const upload = async () => {
		const uploadedFiles = await uploadFilesAndGetLocation(
			uploadMedia,
			setUploadMedia,
			uploadFiles,
			props.topicName
		);

		let uploadState = '';

		if (uploadedFiles.length == uploadMedia.length) {
			console.log('change uploadState success');
			uploadState = uploadStateValues.SUCCESS;
		} else if (uploadedFiles.length === 0) {
			uploadState = uploadStateValues.FAILED;
		} else uploadState = uploadStateValues.PARTIAL;

		if (uploadState === uploadStateValues.FAILED)
			throw Error('An error occured');

		const dto = {
			topicId: props.topicId,
			mediaFiles: uploadedFiles,
			mediaType: props.mediaType
		};

		let endpoint;

		switch (props.mediaType) {
			case MediaType.IMAGES:
				endpoint = 'add-multiple-images';
				break;
			case MediaType.VIDEOS:
				endpoint = 'add-multiple-videos';
				break;
			case MediaType.PHONE_IMAGES:
				endpoint = 'add-multiple-images';
				break;
			case MediaType.PHONE_VIDEOS:
				endpoint = 'add-multiple-videos';
				break;
			default:
				endpoint = 'add-multiple-images';
		}

		const { data: response } = await axiosInstance().put(
			globalEnv.BASE_URL + '/editor/topic/' + endpoint,
			dto,
			{
				headers: {
					Authorization: 'Bearer ' + ACCESS_TOKEN
				}
			}
		);
		return { response: response, uploadState: uploadState };
	};

	useEffect(() => {
		return () => {
			console.log('Unmount!');
		};
	}, []);

	useEffect(() => {
		uploadMedia.length > 0
			? props.setIsChanged(true)
			: props.setIsChanged(false);
	}, [uploadMedia]);

	const { mutate, isLoading } = useMutation(upload, {
		onSuccess: (data) => {
			data.uploadState === uploadStateValues.SUCCESS
				? dispatch(
						SetNotificationAction({
							type: stateNotificationsEnum.SUCCESS,
							message: 'Successfully updated topic info.'
						})
				  )
				: dispatch(
						SetNotificationAction({
							type: stateNotificationsEnum.WARN,
							message: "Couldn't upload all files."
						})
				  );
			let MediaCopy = props.media.slice().reverse();
			data.response.forEach((elem: any) => MediaCopy.push(elem));
			MediaCopy = MediaCopy.reverse();
			props.setMedia(MediaCopy.slice(0, 12));
			props.setMediaCount(props.mediaCount + data.response.length);
			props.setIsChanged(false);
			props.setModalOpen(false);
		},
		onError: () => {
			dispatch(
				SetNotificationAction({
					type: stateNotificationsEnum.ERROR,
					message: 'Failed to update topic.'
				})
			);
		}
	});

	return (
		<div
			className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 
					 w-4/6 h-full md:h-auto ml-8 px-4 py-2 max-h-[80%] mt-10 flex flex-col"
		>
			<section
				className="relative bg-gray-300 w-full max-h-screen overflow-y-auto
									dark:bg-gray-900 transition-colors duration-300 rounded-t-xl"
			>
				<div className="w-full mx-auto ">
					<div className="mx-auto px-4 w-full mt-10">
						<Dropzone
							className="dark:bg-gray-800 z-0 transition-all duration-500"
							onDrop={(files) => {
								if (
									props.mediaType === MediaType.IMAGES ||
									props.mediaType === MediaType.PHONE_IMAGES
								)
									return readImages(
										uploadMedia,
										setUploadMedia,
										uploadFiles,
										setUploadFiles,
										files,
										365 - props.mediaCount
									);
								else
									return readVideos(
										uploadMedia,
										setUploadMedia,
										uploadFiles,
										setUploadFiles,
										files,
										365 - props.mediaCount
									);
							}}
							onReject={(files) => console.log('rejected files', files)}
							maxSize={30 * 1024 ** 2}
							accept={
								props.mediaType === MediaType.IMAGES ||
								props.mediaType === MediaType.PHONE_IMAGES
									? IMAGE_MIME_TYPE
									: ['video/mp4']
							}
						>
							{(status) =>
								dropzoneChildren(
									uploadMedia,
									status,
									theme,
									uploadFiles,
									setUploadFiles,
									setUploadMedia,
									365 - props.mediaCount
								)
							}
						</Dropzone>
					</div>
				</div>
			</section>
			<div
				className="flex flex-row justify-end pt-1 pb-2 px-6 space-x-2 -mt-1
						bg-gray-300 dark:bg-gray-900 shadow-lg transition-colors duration-300 rounded-b-xl"
			>
				<button
					type="button"
					className="btn btn-outline btn-sm btn-error"
					onClick={() => {
						if (props.isChanged) props.setIsWarnModalOpen(true);
						else props.setModalOpen(false);
					}}
					ref={cancelButtonRef}
				>
					Cancel
				</button>
				{props.isChanged && (
					<SaveButton isSaving={isLoading} saveFunc={() => mutate()} />
				)}
			</div>
		</div>
	);
}
